/** People Landing — campos del bloque "marquee". Hasta el 21/09/2026 vivía en BlockEditorDialog.tsx. */
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Plus, Trash2 } from 'lucide-react';
import { ImageField } from '../ImageField';
import type { EditorFieldProps } from '../types';

export function MarqueeFields({ draft, set, imageUrls, pageSlug, setDraft }: EditorFieldProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.section_title', 'Título de sección (opcional)')}</Label>
        <Input value={draft.title ?? ''} onChange={(e) => set({ title: e.target.value })} />
      </div>
      <div className="space-y-2">
        <Label>{t('people_landing.editor.marquee_images', 'Imágenes (hasta 12, en loop horizontal)')}</Label>
        <div className="grid grid-cols-2 gap-3">
          {(draft.imageKeys as (string | undefined)[]).map((k, idx) => (
            <div key={`${k ?? 'new'}-${idx}`} className="relative rounded-lg border p-2">
              <ImageField
                compact
                pageSlug={pageSlug}
                imageKey={k}
                previewUrl={k ? imageUrls[k] : undefined}
                onChange={(nk) =>
                  setDraft((d: any) => ({ ...d, imageKeys: d.imageKeys.map((x: string | undefined, i: number) => (i === idx ? nk : x)) }))
                }
              />
              <Button
                type="button"
                variant="ghost"
                size="sm"
                className="absolute right-1 top-1 h-7 w-7 p-0 text-destructive"
                onClick={() => setDraft((d: any) => ({ ...d, imageKeys: d.imageKeys.filter((_: unknown, i: number) => i !== idx) }))}
              >
                <Trash2 className="h-3.5 w-3.5" />
              </Button>
            </div>
          ))}
        </div>
        {draft.imageKeys.length < 12 && (
          <Button type="button" variant="outline" size="sm" onClick={() => setDraft((d: any) => ({ ...d, imageKeys: [...d.imageKeys, undefined] }))}>
            <Plus className="mr-1.5 h-4 w-4" />
            {t('people_landing.editor.add_image', 'Agregar imagen')}
          </Button>
        )}
      </div>
    </>
  );
}
